// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ojB","wrapper":"_3piE","info":"_4YRm","link":"_3Cz6","text":"pWRy","jobDescription":"_1EB-","weOffer":"_2dMn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/JobInfo/styles.scss
// module id = 465
// module chunks = 0